import React, { useState } from 'react';
import FeedbackForm from './FeedbackForm';

const FeedbackButton = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  return (
    <>
      {/* Floating Feedback Button */}
      <button
        onClick={() => setIsFormOpen(true)}
        className="fixed bottom-6 right-6 z-40 px-4 py-3 rounded-full font-semibold text-white shadow-lg hover:shadow-2xl transition-all transform hover:scale-105 flex items-center gap-2"
        style={{ backgroundImage: 'linear-gradient(to right, #E78E42, #EAC144)' }}
        aria-label="Open feedback form"
      >
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z" clipRule="evenodd" />
        </svg>
        <span className="hidden sm:inline">Feedback</span>
      </button>

      {/* Feedback Form Modal */}
      <FeedbackForm isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} />
    </>
  );
};

export default FeedbackButton;
